import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import { trackEvent } from '../../../../lib/analytics';

import {
    toggleModalTemplateClone,
    toggleTemplateDetails,
} from '../../../../redux/main/main.actions';

import { showNotify } from '../../../../redux/notify/notify.actions';

import { copyToClipboard } from '../../../../utils/copy-to-clipboard';

import './TemplateGrid.scss';

function getDbName(db = '') {
    switch (db) {
        case 'basicsql':
            return 'Basic SQL';
        case 'mysql':
            return 'MySQL';
        case 'postgres':
        case 'postgresql':
            return 'PostgreSQL';
        case 'sqlserver':
            return 'SQL Server';
        case 'oracle':
            return 'Oracle';
        case 'sqlite':
            return 'SQLite';
        case 'snowflake':
            return 'Snowflake';
        case 'mariadb':
            return 'MariaDB';
        default:
            return 'Basic SQL';
    }
}

function TemplateGrid({ data: { id, title, description, db_engine } }) {
    const history = useHistory();
    const dispatch = useDispatch();

    const ref = useRef(null);
    const [isOptionsHovered, setIsOptionsHovered] = useState(false);
    const [isOptionsClicked, setIsOptionsClicked] = useState(false);

    useEffect(() => {
        const handleOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setIsOptionsHovered(false);
                setIsOptionsClicked(false);
            }
        };
        document.addEventListener('mousedown', handleOutside);
        return () => document.removeEventListener('mousedown', handleOutside);
    }, []);


    const handleMenuItemClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOptionsClicked(false);
    };

    const handleMenuClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleCloneTemplateClick = (e) => {
        trackEvent('app_templates_menu_use_template', {
            page: 'app',
            type: 'templates',
            subtype: 'menu',
        });
        dispatch(toggleModalTemplateClone(id));
        handleMenuItemClick(e);
    };

    const handleTemplateDetailsClick = (e) => {
        trackEvent('app_templates_menu_details', {
            page: 'app',
            type: 'templates',
            subtype: 'menu',
        });
        dispatch(toggleTemplateDetails(id));
        handleMenuItemClick(e);
    };

    // const handleCopyTemplateLinkClick = async (e) => {
    //     const baseUrl = window.location.origin;
    //     const path = `/d/${id}`;
    //     const fullUrl = `${baseUrl}${path}`;

    //     try {
    //         await navigator.clipboard.writeText(fullUrl);
    //         dispatch(showNotify({ message: 'link_copied' }));
    //     } catch (err) {
    //         // console.error("error:", err);
    //     }

    //     handleMenuItemClick(e);
    // };
    const handleCopyTemplateLinkClick = async (e) => {
        trackEvent('app_templates_menu_copy_link', {
            page: 'app',
            type: 'templates',
            subtype: 'menu',
        });

        const baseUrl = window.location.origin;
        const path = `/d/${id}`;
        const fullUrl = `${baseUrl}${path}`;

        e?.preventDefault?.();
        const ok = await copyToClipboard(fullUrl);
        if (ok) {
            dispatch(showNotify({ message: 'link_copied' }));
        } else {
            // dispatch(showNotify({ message: 'code_copy_failed' }));
        }

        handleMenuItemClick(e);
    };

    const handleOpenDiagram = (e) => {
        trackEvent('app_templates_click_template', {
            page: 'app',
            type: 'templates',
        });
        e.preventDefault();
        history.push(`/d/${id}`);
    };


    return (
        <a
            // ref={ref}
            className='diagram template-grid'
            href={`/d/${id}`}
            onMouseEnter={() => { setIsOptionsHovered(true); }}
            onMouseLeave={() => { setIsOptionsHovered(false); setIsOptionsClicked(false); }}
            onClick={(e) => { handleOpenDiagram(e); }}
        >
            <div className={`diagram-db-engine template-db-engine ${db_engine}`}>{getDbName(db_engine)}</div>

            <div className='diagram-title template-title'>{title}</div>
            <div className='diagram-description'>{description}</div>

            {isOptionsHovered ?
                <button
                    type="button"
                    className={`element-button options visible ${isOptionsClicked ? 'clicked' : ''}`}
                    onClick={(e) => {
                        trackEvent('app_templates_menu_click', {
                            page: 'app',
                            type: 'templates',
                            subtype: 'menu',
                        });
                        e.preventDefault();
                        e.stopPropagation();
                        setIsOptionsClicked((state) => !state);
                    }}
                >
                    <svg height="28px" width="28px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 488" fill="#000000">
                        <g>
                            <circle cx="51.2" cy="244" r="50"></circle>
                            <circle cx="244" cy="244" r="50"></circle>
                            <circle cx="436.8" cy="244" r="50"></circle>
                        </g>
                    </svg>
                </button>
                : ''
            }
            {isOptionsClicked && (
                <div className={`profile-menu`} onClick={(e) => { handleMenuClick(e); }} >

                    <div className="control">
                        <button
                            className={`control-button`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={(e) => { handleCloneTemplateClick(e); }}
                        >
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"><path d="M8 8V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V12.8C22 13.9201 22 14.4802 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.4802 16 19.9201 16 18.8 16H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z"></path></svg>
                            Use template
                        </button>
                    </div>

                    {/* <div className="horizontal-line"></div> */}

                    <div className="control">
                        <button
                            className={`control-button`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={(e) => { handleTemplateDetailsClick(e); }}
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"></path></svg>
                            See details
                        </button>
                    </div>

                    <div className="control">
                        <button
                            // className={`control-button ${isBtnExportCodeEnabled ? 'selected' : ''}`}
                            className={`control-button`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={(e) => {
                                trackEvent('app_templates_menu_new_tab', {
                                    page: 'app',
                                    type: 'templates',
                                    subtype: 'menu',
                                });
                                handleMenuItemClick(e);
                                window.open(`/d/${id}`, '_blank');
                            }}

                        >
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 9.00001L21 3.00001M21 3.00001H15M21 3.00001L12 12M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V14"></path></svg>
                            Open in new tab
                        </button>
                    </div>


                    {/* <div className="control">
                        <button
                            className={`control-button`}
                            type="button"
                            title=""
                            aria-label="Color"
                            aria-pressed="false"
                            onClick={(e) => { handleCopyTemplateLinkClick(e); }}
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12.7076 18.3639L11.2933 19.7781C9.34072 21.7308 6.1749 21.7308 4.22228 19.7781C2.26966 17.8255 2.26966 14.6597 4.22228 12.7071L5.63649 11.2929M18.3644 12.7071L19.7786 11.2929C21.7312 9.34024 21.7312 6.17441 19.7786 4.22179C17.826 2.26917 14.6602 2.26917 12.7076 4.22179L11.2933 5.636M8.50045 15.4999L15.5005 8.49994"></path></svg>
                            Copy link
                        </button>
                    </div> */}

                </div>
            )}
        </a>
    );
}


export default TemplateGrid;
